import { requestApi } from '@app/api';
import { withDocument } from '@app/api/paths';

interface DocumentFileResponse {
  url: string;
}

// eslint-disable-next-line import/prefer-default-export
export function getDocumentsFile({
  workspaceId,
  documentId,
  participantId,
}: {
  workspaceId: string;
  documentId: string;
  participantId?: string;
}): Promise<DocumentFileResponse> {
  return requestApi<DocumentFileResponse>({
    url: withDocument(`/workspaces/${workspaceId}/documents/${documentId}/file`),
    method: 'GET',
    credentials: true,
    params: participantId ? { participantId } : undefined,
  }).then((response) => response.data);
}
